/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} WorkoutInputs */

const fr_workout = /** @type {(inputs: WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entraînement`)
};

/**

* @param {WorkoutInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const workout = /** @type {((inputs?: WorkoutInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<WorkoutInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_workout(inputs)
});